import { useEffect, useState } from "react";
import { DialogBox } from "@softura/fluentuipackage";
import close from "../../../../../assets/images/Close_SuccessPopup.svg";
import "./PopupDilalogBox.scss";
import { PrimaryButton, OutlineButton, InputField, EventHandler } from "client/CommonComponents";
import { CONSTANTS } from "client/utils/constants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

interface IProps {
    hideDialog?: any;
    onDismiss?: any;
    Popupcontent?: any;
    popupOutlinebtnOnclick?: any;
    popupPrimarybtnOnclick?: any;
    orderDetails?: any;
    requestOption?: any;
    selectedKey?: any;
}

const PopupDialogbox = ({
    hideDialog,
    onDismiss,
    Popupcontent,
    popupOutlinebtnOnclick,
    popupPrimarybtnOnclick,
    orderDetails,
    requestOption,
    selectedKey,
}: IProps) => {
    const [popupComments, setpopupComments] = useState(Popupcontent.comment);
    const [popupCommentError, setPopupCommentError] = useState(false);
    const [popupMessageing, setPopupMessaging] = useState<any>([]);
    const navigate = useNavigate()
    const {
        transferOrderApprovalRequest,
        assetApprovalData
    }: any = useSelector((state: any) => (
        {
            transferOrderApprovalRequest: state.TransferApprovalReducer.transferOrderApprovalRequest,
            assetApprovalData: state.TransferApprovalReducer.assetApprovalData,
        }));
    const popupcommentonchange = (_e: any, text: string) => {

        if (text.length > 500) {
            setPopupCommentError(true);
        } else {
            setPopupCommentError(false);
        }
        setpopupComments(text);
        if (text?.length <= 0) {
            Popupcontent.isCommentBoxRequire = true;
        } else {
            Popupcontent.isCommentBoxRequire = false;
        }
    };
    interface IApproveSummary {
        type: string,
        rejectedCount: number,
        returnedCount: number,
        approvedCount: number
    }
    useEffect(() => {

        setpopupComments(Popupcontent.comment);
    }, [Popupcontent]);
    const popupSavebtnOnclick = () => {

        setpopupComments("");
        popupPrimarybtnOnclick(
            Popupcontent.primaryBtnnavigateTo,
            popupComments,
            Popupcontent.actionby,
            Popupcontent.value
        )
    }
    const popupCancelbtnOnclick = () => {

        setpopupComments("");
        popupOutlinebtnOnclick(Popupcontent.outlineBtnnavigateTo)
    }
    useEffect(() => {

        if (popupComments?.length > 500) {
            setPopupCommentError(true);
        } else {
            setPopupCommentError(false);
        }
    }, [popupComments]);

    const onOrderIdClick = (e: any, orderId: any) => {
        e.preventDefault();
        navigate('/ordermanagement/assetorderdetail/' + orderId + '/home');
    }

    useEffect(() => {
        let approvalSummaryList: IApproveSummary[] = [];

        let transferApproveCountTemp = 0;
        let transferRejectCountTemp = 0;
        let transferReturnCountTemp = 0;

        let dispositionApproveCountTemp = 0;
        let dispositionRejectCountTemp = 0;
        let dispositionReturnCountTemp = 0;

        let reactivationApproveCountTemp = 0;
        let reactivationRejectCountTemp = 0;
        let reactivationReturnCountTemp = 0;


        const requestDetails = orderDetails?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => detailsByIdItem)

        if (requestDetails?.pop()?.orderRequestType === CONSTANTS.TRANSFER_REQUEST) {
            let approvedRequest = transferOrderApprovalRequest?.requestApproveVMs?.length ? transferOrderApprovalRequest?.requestApproveVMs?.filter((item: any) => item?.approverActionId === "1") : []
            if (approvedRequest?.length) {
                transferApproveCountTemp = approvedRequest?.length
            }
            let rejectRequest = transferOrderApprovalRequest?.requestApproveVMs?.length ? transferOrderApprovalRequest?.requestApproveVMs?.filter((item: any) => item?.approverActionId === "2") : []
            if (rejectRequest?.length) {
                transferRejectCountTemp = rejectRequest?.length
            }
            let moreInfoRequest = transferOrderApprovalRequest?.requestApproveVMs?.length ? transferOrderApprovalRequest?.requestApproveVMs?.filter((item: any) => item?.approverActionId === "3") : []
            if (moreInfoRequest?.length) {
                transferReturnCountTemp = moreInfoRequest?.length
            }
        }

        {
            orderDetails?.transferDisposeReactivationDetails?.map((item: any, index: any) => {
                item?.assets?.map((assetItem: any, assetIndex: any) => {
                    if (item?.orderRequestType == CONSTANTS.TRANSFER_REQUEST) {
                        if (Popupcontent.actionby == "approveConfirmationBtn") {
                            transferApproveCountTemp = transferApproveCountTemp + 1
                        } else if (Popupcontent.actionby == "RejectSubmitBtn") {
                            transferRejectCountTemp = transferRejectCountTemp + 1
                        } else if (Popupcontent.actionby == "ReturnSubmitbtn") {
                            transferReturnCountTemp = transferReturnCountTemp + 1
                        }
                    }
                    else if (item?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST) {

                        if (transferOrderApprovalRequest?.requestApproveVMs[assetIndex]?.approverActionId == "1" || Popupcontent.actionby == "approveConfirmationBtn") {
                            dispositionApproveCountTemp = dispositionApproveCountTemp + 1
                        }
                        else if (transferOrderApprovalRequest?.requestApproveVMs[assetIndex]?.approverActionId == "2" || Popupcontent.actionby == "RejectSubmitBtn") {
                            dispositionRejectCountTemp = dispositionRejectCountTemp + 1
                        } else {
                            dispositionReturnCountTemp = dispositionReturnCountTemp + 1
                        }

                    }
                    else if (item?.orderRequestType == CONSTANTS.REACTIVATION_REQUEST) {

                        if (transferOrderApprovalRequest?.requestApproveVMs[assetIndex]?.approverActionId == "1" || Popupcontent.actionby == "approveConfirmationBtn") {
                            reactivationApproveCountTemp = reactivationApproveCountTemp + 1
                        }

                        else if (transferOrderApprovalRequest?.requestApproveVMs[assetIndex]?.approverActionId == "2" || Popupcontent.actionby == "RejectSubmitBtn") {
                            reactivationRejectCountTemp = reactivationRejectCountTemp + 1
                        }

                        else {
                            reactivationReturnCountTemp = reactivationReturnCountTemp + 1
                        }



                    }
                })
            })
            const transferOrdersummary: IApproveSummary = {
                type: CONSTANTS.TRANSFER,
                rejectedCount: transferRejectCountTemp,
                returnedCount: transferReturnCountTemp,
                approvedCount: transferApproveCountTemp
            }
            if (transferRejectCountTemp > 0 || transferReturnCountTemp > 0 || transferApproveCountTemp > 0) {
                approvalSummaryList.push(transferOrdersummary);
            }

            const dispositionOrdersummary: IApproveSummary = {
                type: CONSTANTS.DISPOSITION,
                rejectedCount: dispositionRejectCountTemp,
                returnedCount: dispositionReturnCountTemp,
                approvedCount: dispositionApproveCountTemp
            }
            if (dispositionRejectCountTemp > 0 || dispositionReturnCountTemp > 0 || dispositionApproveCountTemp > 0) {
                approvalSummaryList.push(dispositionOrdersummary);
            }

            const reactivationOrdersummary: IApproveSummary = {
                type: CONSTANTS.REACTIVATION,
                rejectedCount: reactivationRejectCountTemp,
                returnedCount: reactivationReturnCountTemp,
                approvedCount: reactivationApproveCountTemp
            }
            if (reactivationRejectCountTemp > 0 || reactivationReturnCountTemp > 0 || reactivationApproveCountTemp > 0) {
                approvalSummaryList.push(reactivationOrdersummary);
            }
            setPopupMessaging(approvalSummaryList)

        }
    }, [Popupcontent, requestOption])

    const dialogContentProps = {
        title: (
            <>
                <div className="popup-content">
                    <div className="close-btn-Popup">
                        <EventHandler onEvent={() => { popupOutlinebtnOnclick(Popupcontent.outlineBtnnavigateTo) }} data-attribute="PopupDilalogBox_Default_EventHandler_2">
                            <img src={close} alt="close" />
                        </EventHandler>
                    </div>
                    <div className="popup-titleImg">
                        <img src={Popupcontent.titleImg} alt="close" />
                    </div>
                    <div
                        className={Popupcontent.isTitleWarning ? "warning" : "popup-title"}
                    >
                        <p>{Popupcontent.title}</p>
                    </div>
                </div>
            </>
        ),
        closeButtonAriaLabel: "Close",
        subText: (
            <div className="popup-subcontent">
                <div
                    className={
                        Popupcontent.isTitleWarning
                            ? "popup-subtext-warning"
                            : "popup-subtext"
                    }
                >
                    {Popupcontent.subtextcontent}
                </div>
                <div className="popup-commentarea">
                    <div
                        className={
                            Popupcontent.isCommentboxVisible
                                ? "commentBox mb-3"
                                : "commentBox-Notshown"
                        }
                    >
                        <InputField
                            onFocus={(e: any) =>
                                e.currentTarget.setSelectionRange(
                                    e.currentTarget.value.length,
                                    e.currentTarget.value.length
                                )
                            }
                            multiline={true}
                            row="3"
                            value={popupComments}
                            resizable={false}
                            placeholder="Comment"
                            name="text"
                            onChange={popupcommentonchange}
                         data-attribute="PopupDilalogBox_text_Input_2" />
                    </div>
                    {popupCommentError ? (
                        <span className="asset-validation-msg text-danger">
                            {"Please enter comments below 500 characters"}
                        </span>
                    ) : null}
                    <div>
                        {popupMessageing != undefined &&
                            popupMessageing?.map((item: any, index: number) => {
                                return (
                                    <div
                                        key={index}
                                        className={
                                            Popupcontent.isCompletedReportVisible
                                                ? "completed-report mb-3"
                                                : "completed-report-nonactive"
                                        }
                                    >
                                        <div className="left-section">
                                            {(
                                                <p>
                                                    <b>{item.type}</b>
                                                </p>
                                            )}
                                        </div>
                                        <div className="right-section">
                                            {
                                                item.approvedCount != 0 ? (
                                                    <span>
                                                        <span className="fa fa-check-circle-o completed-btn order-status">
                                                            {" "}
                                                        </span>{" "}
                                                        Approved{" "} - {item.approvedCount} {(assetApprovalData?.approvedOrderNo && Popupcontent.actionby != "approveConfirmationBtn") ? <span className="order-group"> <span className="Order-Bold"> Order# : </span><a href="/" onClick={(e: any) => onOrderIdClick(e, assetApprovalData?.approvedOrderNo)}>{assetApprovalData?.approvedOrderNo}</a> </span> : null}
                                                    </span>
                                                ) : null}
                                            {
                                                item.rejectedCount != 0 ? (
                                                    <span>
                                                        <span className="fa fa-times-circle-o rejected-btn order-status">
                                                            {" "}
                                                        </span>{" "}
                                                        Rejected - {item.rejectedCount} {(assetApprovalData?.rejectedOrderNo && Popupcontent.actionby != "RejectSubmitBtn") ? <span className="order-group"> <span className="Order-Bold"> Order# : </span><a href="/" onClick={(e: any) => onOrderIdClick(e, assetApprovalData?.rejectedOrderNo)}>{assetApprovalData?.rejectedOrderNo}</a> </span> : null}
                                                    </span>
                                                ) : null}
                                            {
                                                item.returnedCount != 0 ? (
                                                    <span>
                                                        <span className="fa fa-exclamation-circle returned-btn order-status">
                                                            {" "}
                                                        </span>{" "}
                                                        Request More Info{" "}- {item.returnedCount} {(assetApprovalData?.returnOrderNo && Popupcontent.actionby != "ReturnSubmitbtn") ? <span className="order-group"> <span className="Order-Bold"> Order# : </span><a href="/" onClick={(e: any) => onOrderIdClick(e, assetApprovalData?.returnOrderNo)}>{assetApprovalData?.returnOrderNo}</a></span> : null}
                                                    </span>
                                                ) : null}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
                <div className="popupbtn">
                    <OutlineButton
                        text={Popupcontent.outlineBtnText}
                        onClick={() =>
                            popupCancelbtnOnclick()
                        }
                     data-attribute="PopupDilalogBox_Default_Button_4" />
                    <PrimaryButton
                        text={Popupcontent.primaryBtnText}
                        className={
                            Popupcontent.isSingleConfirmationBtn
                                ? "singleBtnConfirmation"
                                : ""
                        }
                        disabled={
                            (Popupcontent.isCommentBoxRequire && (popupComments?.length <= 0) && (Popupcontent.actionby != "ApproveSubmitBtn" && Popupcontent.actionby != "Approve")) ||
                                popupCommentError
                                ? true
                                : false
                        }
                        onClick={() =>
                            popupSavebtnOnclick()
                        }
                     data-attribute="PopupDilalogBox_Default_Button_5" />
                </div>
            </div>
        ),
        styles: {
            subText: {
                color: "black",
            },
        },
    };

    return (
        <>
            <DialogBox
                hideDialog={hideDialog}
                dialogContentProps={dialogContentProps}
                selectedKey={selectedKey}
             data-attribute="PopupDilalogBox_Default_DialogBox_2"></DialogBox>
        </>
    );
};

export default PopupDialogbox;
